export default __webpack_public_path__ + "media/images/icons_fc/lock-efaddcfd4f21013d5fc2f29e795bc538.png";